import { render, staticRenderFns } from "./muni_F.vue?vue&type=template&id=2c6cae4a"
import script from "./muni_F.vue?vue&type=script&lang=js"
export * from "./muni_F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports